/* eslint-disable react/jsx-no-duplicate-props */
import React, { Component } from 'react'

// ui
import ReactLoading from 'react-loading'

// image
import logo from '../../resource/image/logo.jpg'

// route
import { Redirect } from 'react-router-dom'

// redux
import { connect } from 'react-redux'
import actions from '../../redux/auth/actions'

class LoginScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            username: '',
            password: '',
            isUnameEmpty: false,
            isPassEmpty: false,
        }
    }

    changeStateLoading = () => {
        this.props.history.push('/app/dashboard')
        this.setState({ isLoading: !this.state.isLoading })
    }
    doLogin = () => {
        const { login } = this.props
        const { username, password } = this.state
        if (username === '') {
            this.setState({ isUnameEmpty: true })
        } else if (password === '') {
            this.setState({ isPassEmpty: true })
        } else {
            login(username, password)
        }
    }
    onEnterPress = e => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            e.preventDefault()
            this.doLogin()
        }
    }

    render() {
        let from = null
        try {
            if (this.props.location.state.from)
                from = this.props.location.state.from
            else from = null
        } catch {}

        if (this.props.isLoggedIn) {
            if (from) return <Redirect to={from} />

            return <Redirect to={'app/dashboard'} />
        }
        const { isUnameEmpty, isPassEmpty } = this.state

        return (
            <div className="LoginScreen">
                <div className="LoginCard">
                    <img className="Image" src={logo} alt="logo" />
                    <div className="SubTitle">HỆ THỐNG QUẢN LÝ CÔNG VIỆC</div>

                    <div className="Row">
                        <input
                            type="text"
                            className="UserNameTextBox"
                            placeholder="Tên đăng nhập"
                            value={this.state.username}
                            onChange={e =>
                                this.setState({
                                    username: e.target.value,
                                    isUnameEmpty: false,
                                })
                            }
                            onKeyDown={this.onEnterPress}
                        />
                        {isUnameEmpty && (
                            <span>Bạn chưa nhập tên tài khoản</span>
                        )}
                        <input
                            type="password"
                            className="PasswordTextBox"
                            placeholder="Mật khẩu"
                            value={this.state.password}
                            onChange={e =>
                                this.setState({
                                    password: e.target.value,
                                    isPassEmpty: false,
                                })
                            }
                            onKeyDown={this.onEnterPress}
                        />
                        {isPassEmpty && (
                            <span style={{ color: 'red' }}>
                                Bạn chưa nhập mật khẩu
                            </span>
                        )}
                        <button
                            className="row"
                            onClick={() => this.changeStateLoading()}
                            onClick={this.doLogin}
                        >
                            {this.state.isLoading ? (
                                <ReactLoading
                                    className="Loading"
                                    type="spin"
                                    height="18px"
                                    width="18px"
                                />
                            ) : null}
                            Đăng nhập
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        isLoggedIn: state.auth.isLoggedIn,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        login: (username, password) => {
            dispatch(actions.action.login(username, password))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginScreen)
